import React,{useEffect} from 'react'
import './Skills.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFigma, faCss3Alt, faJs, faGithub, faGit, faReact, faSass, faHtml5} from '@fortawesome/free-brands-svg-icons'

const Skills = () => {
        
        function pickRandomSkill(){
            const tags = document.querySelectorAll('.skillsIcon');
            return tags[Math.floor(Math.random() * tags.length)];
        }
        function highLightSkills(skill) {
            skill.classList.add('active');
        }
        function unHighLightSkills(skill) {
            skill.classList.remove('active');
        }

         function highlightSkills() {
            const interval = setInterval(() => {
                const skill =  pickRandomSkill()
                highLightSkills(skill);
                setTimeout(() => {
                    unHighLightSkills(skill)
            }, 1000);
            }, 1000);
         }
         useEffect(() => {
             highlightSkills();
         }, [])
         
    return (
        <>
            <div className="sections">
                <div className="section-title"><span>02 .</span><h3>My Skills</h3></div>
                <div className="skills-main-sec">
                    <div className="skills-crd-container">
                        <div className="skills-crd">
                            <h2 className="skill-crd-title">Frontend Development</h2>
                            <p className="skill-experience">Around 1 Year Experience</p>
                            <div className="skills-lists">
                             <FontAwesomeIcon icon={faHtml5} className="skillsIcon" size='4x'/>
                             <FontAwesomeIcon icon={faCss3Alt} className="skillsIcon" size='4x'/>
                             <FontAwesomeIcon icon={faSass} className="skillsIcon" size='4x'/>
                             <FontAwesomeIcon icon={faJs} className="skillsIcon" size='4x'/>
                             <FontAwesomeIcon icon={faReact} className="skillsIcon" size='4x'/>
                            </div>
                        </div>
                        <div className="skills-crd">
                            <h4 className="skill-crd-title">Other Skills</h4>
                            <p className="skill-experience">Around 4 Months Of Experience</p>
                            <div className="skills-lists">
                             <FontAwesomeIcon icon={faGit} className="skillsIcon" size='4x'/>
                             <FontAwesomeIcon icon={faGithub} className="skillsIcon" size='4x'/>
                             <FontAwesomeIcon icon={faFigma} className="skillsIcon" size='4x'/>
                             <div className="skillsIcon" data-text="Ps">Ps</div>
                            </div>
                        </div>
                    </div>
                    <p className="skills-note" id='projectSection'><span>Note : </span>I'm willing to learn Other Skills As Required</p>
                </div>
            </div>
        </>
    )
}

export default Skills;